<!--
사용자정보 > 비용관련 칼럼들 수정 컴포넌트
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-large">

            <div class="uk-modal-header">
                <h4><i class="material-icons">edit</i>회원 기본비용 설정</h4>
            </div>

            <div class="uk-modal-body uk-padding-small">
                <table class="info-table small uk-width-1-1">
                    <colgroup>
                        <col style="width: 12rem">
                        <col>
                    </colgroup>
                    <tbody>
                    <tr>
                        <th class="uk-text-right">
                            회원사
                        </th>
                        <td class="uk-text-left">
                            {{ user.nick }}
                        </td>
                    </tr>
                    <tr>
                        <th class="uk-text-right">
                            사서함
                        </th>
                        <td class="uk-text-left">
                            {{ user.mailbox }}
                        </td>
                    </tr>
                    <tr>
                        <th class="uk-text-right" @click="$refs.customs_clearance_cost.inputFocus()">
                            일반통관수수료(KRW)
                        </th>
                        <td class="uk-text-center">
                            <app-input-text
                                ref="customs_clearance_cost"
                                v-model="inputs.customs_clearance_cost"
                            ></app-input-text>
                        </td>
                    </tr>
                    <tr>
                        <th class="uk-text-right" @click="$refs.customs_clearance_biz_cost.inputFocus()">
                            사업자통관수수료(KRW)
                        </th>
                        <td class="uk-text-center">
                            <app-input-text
                                ref="customs_clearance_biz_cost"
                                v-model="inputs.customs_clearance_biz_cost"
                            ></app-input-text>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>

                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    @click="submit"
                >
                    <span uk-icon="icon: check"></span>
                    저장
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            /**
             * csrf token
             */
            csrfToken: {
                type: String,
                required: true,
            },


        },
        data: function () {
            return {
                /**
                 * (object) user
                 */
                user: {},

                /**
                 * (object) 입력값
                 */
                inputs: {
                    customs_clearance_cost: null,
                    customs_clearance_biz_cost: null,
                },


            };
        },
        computed: {

        },
        methods: {
            /**
             * 입력폼 display
             */
            show() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param user_id
             */
            form(user_id) {

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/users/' + user_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.background(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.user = response.user;

                    // 입력값 초기화
                    this.inputs.customs_clearance_cost = this.user.customs_clearance_cost;
                    this.inputs.customs_clearance_biz_cost = this.user.customs_clearance_biz_cost;

                    // 폼띄우기
                    this.show();
                });
            },

            /**
             * submit
             */
            submit() {
                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/users/' + this.user.id,
                    data: _.merge({
                        '_token': this.csrfToken,
                    }, this.inputs),
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>